"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "trapani": {
    "120a639f": [{
      "hkey": "ceceac32",
      "slug": "milo-villa-rosina",
      "name": "Milo-Villa Rosina",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "22ea7574",
      "slug": "xitta",
      "name": "Xitta",
      "primary": false,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "ceceac32",
      "slug": "milo-villa-rosina",
      "name": "Milo-Villa Rosina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "trapani"
    }],
    "f711fe7d": [{
      "hkey": "ceceac32",
      "slug": "milo-villa-rosina",
      "name": "Milo-Villa Rosina",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "22ea7574",
      "slug": "xitta",
      "name": "Xitta",
      "primary": false,
      "skipSearch": false
    }],
    "semi-periferia": [{
      "hkey": "ceceac32",
      "slug": "milo-villa-rosina",
      "name": "Milo-Villa Rosina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "trapani"
    }],
    "813e3f1f": [{
      "hkey": "9d5ea0a7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "zona-pregiata": [{
      "hkey": "9d5ea0a7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;